import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=fe0912f6&scoped=true&"
import script from "./MainCarousel.vue?vue&type=script&lang=js&"
export * from "./MainCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MainCarousel.vue?vue&type=style&index=0&id=fe0912f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0912f6",
  null
  
)

export default component.exports